// extracted by mini-css-extract-plugin
export default {"wrapper":"ZmXDWdHTB8egRQsKZ5vL","icon":"lKiBYc0_1_UfhsLsALNx","warning":"GHnSSkg2msqi7do1I4UL"};